type CloseWatcherLike = { onclose: (() => void) | null; destroy: () => void };

/**
 * Let Android's back button (and Esc on a keyboard) close an open sheet or
 * overlay that is not a modal dialog, the way Chrome already closes a
 * <dialog>: the newest open one closes and the page stays put. Browsers
 * without CloseWatcher keep their usual back. Returns a function that stops
 * watching; call it when the overlay closes some other way.
 */
export function watchCloseRequest(onClose: () => void): () => void {
  const Watcher = (globalThis as { CloseWatcher?: new () => CloseWatcherLike }).CloseWatcher;
  if (!Watcher) return () => {};
  const watcher = new Watcher();
  watcher.onclose = onClose;
  return () => watcher.destroy();
}
